var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.card.cardType === _setup.LPU_CARD_TYPE.PARTNER
    ? _c(_setup.LpuSetCard, _vm._b({}, "LpuSetCard", _vm.card.props, false))
    : _c(_setup.LpuCard, _vm._b({}, "LpuCard", _vm.card.props, false))
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }